// Data seam for the per-user notification matrix ("Mi cuenta → Notificaciones").
// Each person chooses, per event, which channels reach them, and these choices
// are their own (global across the workspaces they belong to). Wired to the
// account API: getNotificationPreferences() -> GET the resolved matrix (catalog
// defaults overlaid with the user's stored choices, filtered to the events their
// roles can receive); setNotificationPreference() -> PATCH one (event, channel)
// cell. Always-on events come back with in_app `locked` so the UI shows it
// fixed-on instead of a toggle.

import { apiClient } from '../../api/client.js'

export interface NotifChannelState {
  enabled: boolean
  /** True when the cell can't be toggled (always-on event's in-app alert). */
  locked: boolean
}

export interface NotifPrefEvent {
  type: string
  label: string
  group: string
  alwaysOn: boolean
  channels: Record<string, NotifChannelState>
}

export interface NotifMeta {
  key: string
  label: string
}

export interface NotifPrefsMatrix {
  groups: NotifMeta[]
  channels: NotifMeta[]
  events: NotifPrefEvent[]
}

/**
 * GET /account/notification-preferences — the resolved event×channel matrix
 * (catalog defaults + stored choices, filtered to the user's roles). Always-on
 * events arrive with in_app `locked: true`.
 */
export async function getNotificationPreferences(): Promise<NotifPrefsMatrix> {
  const res = await apiClient.get<{ data: NotifPrefsMatrix }>('/account/notification-preferences')
  return res.data.data
}

/** PATCH /account/notification-preferences — toggles a single (event, channel) cell. */
export async function setNotificationPreference(
  eventType: string,
  channel: string,
  enabled: boolean,
): Promise<void> {
  await apiClient.patch('/account/notification-preferences', { eventType, channel, enabled })
}
